module.exports = __webpack_public_path__ + "img/m_default_banner_bg.7dfaa3aa.png";